export const RESET_FORM_DATA = 'form//RESET_FORM_DATA'

export const SAVE_FORM_DATA = 'form//SAVE_FORM_DATA'

export const ADD_CONTACT_DATA = 'form/ADD_CONTACT_DATA'

export const SAVE_FORM_PERSONAL_DATA = 'form//SAVE_FORM_PERSONAL_DATA'

export const SAVE_FORM_CONTACT_DATA = 'form//SAVE_FORM_CONTACT_DATA'

export const SAVE_FORM_EMPLOYMENT_DATA = 'form//SAVE_FORM_EMPLOYMENT_DATA'

export const SAVE_FORM_FINANCIAL_DATA = 'form//SAVE_FORM_FINANCIAL_DATA'

export const SAVE_FORM_PROTECTION_DATA = 'form//SAVE_FORM_PROTECTION_DATA'

export const SET_VALIDATING_IBAN = 'form//SET_VALIDATING_IBAN'

export const SET_ID_DOCUMENTS_UPLOADED_CLAVE = 'form//SET_ID_DOCUMENTS_UPLOADED_CLAVE'

interface GenericObject {
  [key: string]: any
}

interface FormState {
  data: GenericObject
  validatingIban: boolean
  idDocumentsUploadedClave: boolean
}

interface FormStore {
  form: FormState
}

interface FormAction {
  type: string
  payload?: any
}

export function saveFormData(data: GenericObject): FormAction {
  return {
    type: SAVE_FORM_DATA,
    payload: data,
  }
}

export function savePersonalDetailsData(data: GenericObject): FormAction {
  return {
    type: SAVE_FORM_PERSONAL_DATA,
    payload: data,
  }
}

export function saveContactDetailsData(data: GenericObject): FormAction {
  return {
    type: SAVE_FORM_CONTACT_DATA,
    payload: data,
  }
}

export function saveEmploymentData(data: GenericObject): FormAction {
  return {
    type: SAVE_FORM_EMPLOYMENT_DATA,
    payload: data,
  }
}

export function saveFinancialData(data: GenericObject): FormAction {
  return {
    type: SAVE_FORM_FINANCIAL_DATA,
    payload: data,
  }
}

export function saveDataProtectionData(data: GenericObject): FormAction {
  return {
    type: SAVE_FORM_PROTECTION_DATA,
    payload: data,
  }
}

export function addContactData(data: GenericObject): FormAction {
  return {
    type: ADD_CONTACT_DATA,
    payload: data,
  }
}

export function resetFormData(): FormAction {
  return {
    type: RESET_FORM_DATA,
  }
}

export function setValidatingIban(data: boolean): FormAction {
  return {
    type: SET_VALIDATING_IBAN,
    payload: data,
  }
}

export function setIdDocumentsUploadedClave(data: boolean): FormAction {
  return {
    type: SET_ID_DOCUMENTS_UPLOADED_CLAVE,
    payload: data,
  }
}

export function getFormData(store: FormStore): GenericObject {
  return store.form.data
}

export function getValidatingIban(store: FormStore): boolean {
  return store.form.validatingIban
}

export function getIdDocumentsUploadedClave(store: FormStore): boolean {
  return store.form.idDocumentsUploadedClave
}

const initialState: FormState = {
  data: {},
  validatingIban: false,
  idDocumentsUploadedClave: false,
}

export default function formReducer(
  state: FormState = initialState,
  action: FormAction,
): FormState {
  switch (action.type) {
    case RESET_FORM_DATA:
      return {
        ...state,
        data: {},
      }

    case SAVE_FORM_DATA:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload,
        },
      }

    case SAVE_FORM_PERSONAL_DATA:
      return {
        ...state,
        data: {
          ...state.data,
          customerData: {
            ...state.data.customerData,
            gender: action.payload.gender,
            firstName: action.payload.firstName,
            lastName: action.payload.lastName,
            secondaryLastName: action.payload.secondaryLastName || undefined,
            dateOfBirth: action.payload.dateOfBirth,
            nationality: action.payload.nationality,
            maritalStatus: action.payload.maritalStatus,
            personalId: {
              id: action.payload.personalId,
            },
          },
        },
      }

    case SAVE_FORM_CONTACT_DATA:
      return {
        ...state,
        data: {
          ...state.data,
          customerData: {
            ...state.data.customerData,
            ...action.payload,
          },
        },
      }

    case SAVE_FORM_FINANCIAL_DATA:
      return {
        ...state,
        data: {
          ...state.data,
          customerData: {
            ...state.data.customerData,
            iban: action.payload?.iban,
            financialDisclosure: {
              ...action.payload.financialDisclosure,
            },
          },
        },
      }

    case SAVE_FORM_EMPLOYMENT_DATA:
      return {
        ...state,
        data: {
          ...state.data,
          customerData: {
            ...state.data.customerData,
            ...action.payload,
          },
        },
      }

    case SAVE_FORM_PROTECTION_DATA:
      return {
        ...state,
        data: {
          ...state.data,
          dataProtection: {
            promotion: {
              transferFinancialServicesSpain:
                action.payload.transferFinancialServicesSpain === 'true',
              transferVWServicesGroup:
                action.payload.transferVWServicesGroup === 'true',
              transferVWServicesDealer:
                action.payload.transferVWServicesDealer === 'true',
            },
            acceptPrivacyPolicy: action.payload.acceptPrivacyPolicy,
          },
        },
      }

    case ADD_CONTACT_DATA:
      return {
        ...state,
        data: {
          ...state.data,
          DACcustomerData: {
            ...state.data.DACcustomerData,
            ...action.payload,
          },
        },
      }

    case SET_VALIDATING_IBAN:
      return {
        ...state,
        validatingIban: action.payload,
      }

    case SET_ID_DOCUMENTS_UPLOADED_CLAVE:
      return {
        ...state,
        idDocumentsUploadedClave: action.payload,
      }

    default:
      return state
  }
}
